import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class BringozDayTimeWindowBarComponent implements IController {

  hours: number[];

  constructor(private splitService) {
  }

  $onInit() {
    const format = this.splitService.getDateAndTimeConfig().time;
    let hours = [];
    _.times(24,  (i) => {
      if (format === 'hh:mm A' && i >= 13) {
        i = i - 12;
      }
      hours.push(i);
    });
    this.hours = hours;
  };

  $onChanges(changes) {
    if (changes.dates && !changes.dates.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.commons')
  .component('bringozDayTimeWindowBar', {
    bindings: {},
    templateUrl: 'app/modules/commons/components/bringoz-day-time-window-bar/bringoz-day-time-window-bar.html',
    controller: BringozDayTimeWindowBarComponent
  });
